import { useAuth0 } from '@auth0/auth0-react'
import { useGetAllProjectsByUserAdmin } from 'lib/react-query/queriesProject'
import { useMemo } from 'react'
import ProyectoCardItem from './ProyectoCardItem'
import Pagination from 'components/ui/Pagination/Pagination'
import ProyectosArraySkeleton from 'components/Loaders/ProyectosArraySkeleton'
import CreateProject2 from 'pages/admin/Proyectos/CreateProject2'

import { useNavigate, useSearchParams } from 'react-router-dom'

const LIMIT_PAGINATION = 7

const ProyectosAdminList = () => {
  const navigate = useNavigate()
  const [searchParams, setSearchParams] = useSearchParams()
  const page = parseInt(searchParams.get('page')) || 1

  const { user } = useAuth0()
  const { data, isLoading } = useGetAllProjectsByUserAdmin(user.sub, {
    page,
    limit: LIMIT_PAGINATION,
  })

  const totalPages = useMemo(() => {
    return data?.total ? Math.ceil(data.total / LIMIT_PAGINATION) : 1
  }, [data?.total])

  const handleNavigate = () => navigate('/admin/proyectos/form-admin')

  const handleOnClickProject = id => navigate(`/admin/proyectos/${id}`)

  const handlePageProyectos = currentPage => {
    if (
      currentPage < 1 ||
      currentPage > Math.ceil(data.total / LIMIT_PAGINATION)
    )
      return // Evita valores fuera del rango
    setSearchParams({
      page: currentPage,
    })
  }

  if (isLoading) return <ProyectosArraySkeleton length={8} />

  return (
    <div className="proyectos-container-layout container">
      <div className="proyectos-container">
        <CreateProject2 onClick={handleNavigate} />

        {data?.data?.data?.length > 0 ? (
          data.data.data.map(item => (
            <ProyectoCardItem
              key={item._id}
              item={item}
              handleOnClick={() => handleOnClickProject(item._id)}
            />
          ))
        ) : (
          <p>No hay proyectos disponibles</p>
        )}
      </div>

      {totalPages > 1 && (
        <Pagination
          currentPage={page}
          totalPages={Math.ceil(data.total / LIMIT_PAGINATION)}
          handlePage={value => handlePageProyectos(value)}
        />
      )}
    </div>
  )
}

export default ProyectosAdminList
